import { render, staticRenderFns } from "./KeywordModalCard.vue?vue&type=template&id=b0129dd8&scoped=true"
import script from "./KeywordModalCard.vue?vue&type=script&lang=js"
export * from "./KeywordModalCard.vue?vue&type=script&lang=js"
import style0 from "./KeywordModalCard.vue?vue&type=style&index=0&id=b0129dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0129dd8",
  null
  
)

export default component.exports